// extracted by mini-css-extract-plugin
export default {"container":"B0-z","list":"C0-z"};